class FreeShippingBar extends HTMLElement {
  constructor() {
    super();
    this.onCartUpdated = this.onCartUpdated.bind(this);
    this.onTextActivate = this.onTextActivate.bind(this);
  }

  connectedCallback() {
    this.threshold = Number(this.dataset.value || 0);
    this.progressEl = this.querySelector('[data-js-progress]');
    this.textEl = this.querySelector('[data-js-text]');
    this.messageIncomplete = this.dataset.messageIncomplete || '';
    this.messageComplete = this.dataset.messageComplete || '';
    this.popupDrawerSelector = this.dataset.popupDrawer || '';

    document.addEventListener('cart:updated', this.onCartUpdated);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdated);
    }

    if (this.textEl && this.popupDrawerSelector) {
      this.textEl.addEventListener('click', this.onTextActivate);
      this.textEl.addEventListener('keydown', this.onTextActivate);
      this.enhanceHighlights();
    }
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.onCartUpdated);
    this.cartUpdateUnsubscriber?.();
    if (this.textEl) {
      this.textEl.removeEventListener('click', this.onTextActivate);
      this.textEl.removeEventListener('keydown', this.onTextActivate);
    }
  }

  onCartUpdated(event) {
    const cart = event?.detail?.cart || event?.cart;
    if (cart && typeof cart.total_price === 'number') {
      this.update(cart.total_price);
      return;
    }

    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
      .then((response) => response.json())
      .then((data) => this.update(data.total_price))
      .catch(() => {});
  }

  update(totalPrice) {
    if (!this.threshold) return;

    const remaining = Math.max(this.threshold - totalPrice, 0);
    const percent = Math.min(totalPrice / (this.threshold / 100), 100);

    if (this.progressEl) {
      this.progressEl.style.width = `${percent}%`;
    }

    this.classList.toggle('free-shipping-bar--complete', remaining === 0);
    this.classList.toggle('is-empty', totalPrice === 0);

    if (!this.textEl) return;

    if (remaining > 0) {
      const money = window.Shopify?.formatMoney
        ? Shopify.formatMoney(remaining, window.money_format)
        : (remaining / 100).toFixed(2);

      this.textEl.innerHTML = this.messageIncomplete.replace('{{ value }}', money);
    } else {
      this.textEl.innerHTML = this.messageComplete;
    }

    this.enhanceHighlights();
  }

  enhanceHighlights() {
    if (!this.textEl || !this.popupDrawerSelector) return;

    this.textEl.querySelectorAll('.free-shipping-bar__highlight').forEach((el) => {
      el.classList.add('free-shipping-bar__highlight--link');
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      if (!el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', el.textContent.trim() || 'Free Shipping');
      }
    });
  }

  onTextActivate(event) {
    const highlight = event.target.closest?.('.free-shipping-bar__highlight');
    if (!highlight || !this.contains(highlight)) return;

    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (event.type === 'keydown') event.preventDefault();

    const drawer = document.querySelector(this.popupDrawerSelector);
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(highlight);
    }
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}
